import './styles/main.css';
import { setupApp } from './app';
import { registerRoute, rerender, startRouter } from './router';
import { syncSessionFromStorage } from './state';
import { mountAchievements, unmountAchievements } from './pages/achievements';
import { mountAdmin, unmountAdmin } from './pages/admin';
import { mountContacts } from './pages/contacts';
import { mountHistory, unmountHistory } from './pages/history';
import { mountHome, unmountHome } from './pages/home';
import { mountJoin } from './pages/join';
import { mountMedia, unmountMedia } from './pages/media';
import { mountNews, unmountNews } from './pages/news';
import { mountPlayer, unmountPlayer } from './pages/player';
import { mountRoster, unmountRoster } from './pages/roster';

syncSessionFromStorage();
setupApp();

registerRoute('/', { screen: 'screen-home', titleKey: 'nav.home', mount: mountHome, unmount: unmountHome });
registerRoute('/news', { screen: 'screen-news', titleKey: 'nav.news', mount: mountNews, unmount: unmountNews });
registerRoute('/roster', { screen: 'screen-roster', titleKey: 'nav.roster', mount: mountRoster, unmount: unmountRoster });
registerRoute('/player', { screen: 'screen-player', titleKey: 'player.card', nav: '/roster', mount: mountPlayer, unmount: unmountPlayer });
registerRoute('/achievements', { screen: 'screen-achievements', titleKey: 'nav.achievements', mount: mountAchievements, unmount: unmountAchievements });
registerRoute('/media', { screen: 'screen-media', titleKey: 'nav.media', mount: mountMedia, unmount: unmountMedia });
registerRoute('/join', { screen: 'screen-join', titleKey: 'nav.join', mount: mountJoin });
registerRoute('/contacts', { screen: 'screen-contacts', titleKey: 'nav.contacts', mount: mountContacts });
registerRoute('/history', { screen: 'screen-history', titleKey: 'nav.history', mount: mountHistory, unmount: unmountHistory });
registerRoute('/admin', { screen: 'screen-admin', titleKey: 'nav.admin', mount: mountAdmin, unmount: unmountAdmin });

document.addEventListener('i18n:changed', rerender);

startRouter();

// Preloader: reveal once bootstrapped, with a hard fallback.
window.setTimeout(() => document.body.classList.add('is-ready'), 60);
window.setTimeout(() => document.body.classList.add('is-ready'), 3000);
